import styled from "styled-components";
import { compose } from "redux";
import { connect } from "react-redux";
import PropType from "prop-types";
import { useContext } from "react";
import DefinitionTypes from "../../../utils/definition-types";
import {
  selectDiscoverySelectedKPIs,
  selectDiscoveryScenario
} from "../../../store/reducers";
import FinancialCard from "./FinancialCard";
import Masonry from "../../../components/Masonry";
import { useMobileMediaQuery } from "../../../components/Responsive";
import {
  sortDiscoveryKPIsByImportance,
  sortDiscoveryKPIsByValue
} from "../../../utils/sorting";
import ViewValueHypothesisKPIsBy from "../../../utils/view-value-hypothesis-kpis-by";
import { ValueHypothesisContext } from "./ValueHypothesisProvider";

const FinancialCards = ({
  selectedKPIs,
  reportId,
  isShowAllChallenges,
  showAllHypotheses,
  printMode,
  scenario
}) => {
  const isMobile = useMobileMediaQuery();
  // Get sortBy from ValueHypothesisProvider
  const { sortBy } = useContext(ValueHypothesisContext);
  const sortedKPIs = [...selectedKPIs];

  sortedKPIs.sort((a, b) => {
    if (!reportId) {
      if (
        a.definition &&
        a.definition.status === DefinitionTypes.NEW &&
        (!b.definition || b.definition.status !== DefinitionTypes.NEW) &&
        !a.viewed
      ) {
        return -1;
      } else if (
        (!a.definition || a.definition.status !== DefinitionTypes.NEW) &&
        b.definition &&
        b.definition.status === DefinitionTypes.NEW &&
        !a.viewed
      ) {
        return 1;
      }
    }

    // Apply sorting based on sortBy setting from context
    if (sortBy === ViewValueHypothesisKPIsBy.VALUE) {
      return sortDiscoveryKPIsByValue(scenario)(a, b);
    } else {
      return sortDiscoveryKPIsByImportance(a, b);
    }
  });

  return (
    <>
      {isMobile ? (
        (showAllHypotheses ? sortedKPIs : sortedKPIs.slice(0, 4)).map(
          (kpi, index) => (
            <MarginContainer key={index} className={"mobile"}>
              <FinancialCard
                kpiCode={kpi.kpiCode}
                reportId={reportId}
                showAllChallenges={isShowAllChallenges}
              />
            </MarginContainer>
          )
        )
      ) : (
        <MasonryContainer>
          <Masonry
            breakpointCols={{
              default: 2,
              1200: 1
            }}
          >
            {sortedKPIs.map((kpi, index) => (
              <MarginContainer key={index}>
                <FinancialCard
                  kpiCode={kpi.kpiCode}
                  reportId={reportId}
                  showAllChallenges={isShowAllChallenges}
                  printMode={printMode}
                />
              </MarginContainer>
            ))}
          </Masonry>
        </MasonryContainer>
      )}
    </>
  );
};

const MarginContainer = styled.div`
  margin-bottom: 18px;

  &.mobile {
    margin-bottom: 16px;
  }

  &.mobile:last-child {
    margin-bottom: 0;
  }
`;

const MasonryContainer = styled.div`
  padding-bottom: 40px;
`;

FinancialCards.propType = {
  reportId: PropType.string,
  isShowAllChallenges: PropType.bool.isRequired,
  showAllHypotheses: PropType.bool.showAllHypotheses,
  printMode: PropType.bool
};

const mapStateToProps = (state) => ({
  selectedKPIs: selectDiscoverySelectedKPIs(state),
  scenario: selectDiscoveryScenario(state)
});

export default compose(connect(mapStateToProps))(FinancialCards);
